// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"542":"f589f2b2","960":"352aaf84"}[chunkId] + ".js";
};